import { Dices, Star, Flame, Users } from "lucide-react";
import { StatsCard } from "./StatsCard";

export interface MachineStats {
  totalSpins: number;
  tierWins: number;
  tierName: string;
  tierColor?: string;
  currentGap: number;
  activeUsers: number;
  isMultiTierView?: boolean;
}

interface StatsGridProps {
  stats: MachineStats;
  isLoading?: boolean;
}

export function StatsGrid({ stats, isLoading }: StatsGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="h-32 rounded-xl bg-card border border-border animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 ${stats.isMultiTierView ? "lg:grid-cols-2" : "lg:grid-cols-4"}`}>
      <StatsCard
        title="Total Spins"
        value={stats.totalSpins}
        icon={<Dices className="h-6 w-6" />}
        iconColor="default"
      />
      {!stats.isMultiTierView && (
        <StatsCard
          title={stats.tierName}
          value={stats.tierWins}
          icon={<Star className="h-6 w-6" style={stats.tierColor ? { color: stats.tierColor } : undefined} />}
          iconColor={stats.tierColor ? undefined : "yellow"}
          customIconColor={stats.tierColor}
        />
      )}
      {!stats.isMultiTierView && (
        <StatsCard
          title="Current Gap"
          value={stats.currentGap}
          icon={<Flame className="h-6 w-6" />}
          iconColor="orange"
        />
      )}
      <StatsCard
        title="Active Users"
        value={stats.activeUsers}
        icon={<Users className="h-6 w-6" />}
        iconColor="green"
      />
    </div>
  );
}
